const TITLE_ATTRS = { size: "20px", color: "#0047b2", bold: true };
const BODY_ATTRS = { size: "16px" };

const SECTION_LABELS = {
  descriptionEs: "Descripción",
  descriptionEn: "Description",
  featuresEs: "Características y beneficios",
  featuresEn: "Characteristics and benefits",
};

const FEATURES_SPLIT_RE =
  /\n?\s*(?:Caracter[ií]sticas y [Bb]eneficios|Characteristics and [Bb]enefits)\s*/i;
const FEATURES_INLINE_RE =
  /(?:Caracter[ií]sticas y [Bb]eneficios|Characteristics and [Bb]enefits)\s*[•—\-–]/i;
const SECTION_ONLY_RE =
  /^(DESCRIPCI[OÓ]N|DESCRIPTION|CARACTER[IÍ]STICAS Y BENEFICIOS|CHARACTERISTICS AND BENEFITS|Descripci[oó]n|Description|Caracter[ií]sticas y beneficios|Characteristics and benefits)$/i;

function toSentenceCase(value) {
  const lower = String(value).toLocaleLowerCase("es-MX").trim();
  if (!lower) return "";
  return lower.charAt(0).toLocaleUpperCase("es-MX") + lower.slice(1);
}

function titleOps(label) {
  return [
    { attributes: { ...TITLE_ATTRS }, insert: label },
    { attributes: { header: 4 }, insert: "\n" },
    { insert: "\n" },
  ];
}

function paragraphOps(text) {
  const clean = String(text || "").trim();
  if (!clean) return [];
  return [{ attributes: { ...BODY_ATTRS }, insert: clean }, { insert: "\n\n" }];
}

function bulletOps(text) {
  let clean = String(text || "").trim().replace(/^[•—\-–]\s*/, "");
  if (!clean) return [];
  if (!/[.!?]$/.test(clean)) clean = `${clean}.`;
  return [
    { attributes: { ...BODY_ATTRS }, insert: clean },
    { attributes: { list: "bullet" }, insert: "\n" },
  ];
}

function splitBullets(rest) {
  return String(rest || "")
    .split(/\n\s*[•—\-–]\s*|\s*[•—\-–]\s+/)
    .map((item) => item.trim())
    .filter(Boolean);
}

function rebuildFromFlatText(fullText) {
  const isEnglish = /Characteristics and [Bb]enefits/i.test(fullText);
  const featuresLabel = isEnglish
    ? SECTION_LABELS.featuresEn
    : SECTION_LABELS.featuresEs;
  const descriptionLabel = isEnglish
    ? SECTION_LABELS.descriptionEn
    : SECTION_LABELS.descriptionEs;

  const parts = fullText.split(FEATURES_SPLIT_RE);
  let description = (parts[0] || "")
    .replace(/^\s*(?:Descripci[oó]n|Description)\s*/i, "")
    .trim();
  const bullets = splitBullets(parts[1] || "");

  const ops = [
    ...titleOps(descriptionLabel),
    ...paragraphOps(description),
    ...titleOps(featuresLabel),
  ];
  bullets.forEach((item) => ops.push(...bulletOps(item)));
  return { ops };
}

function promoteSectionTitles(ops) {
  const out = [];
  for (let i = 0; i < ops.length; i += 1) {
    const op = ops[i];
    const insert = typeof op.insert === "string" ? op.insert : "";
    const trimmed = insert.trim();
    const next = ops[i + 1];
    const alreadyHeader = next?.attributes?.header === 4;

    if (trimmed && SECTION_ONLY_RE.test(trimmed) && !alreadyHeader) {
      out.push(...titleOps(toSentenceCase(trimmed)));
      if (insert.endsWith("\n") && insert.replace(/\n/g, "") === trimmed) {
        // title was the whole insert including trailing newline
      }
      continue;
    }

    if (
      trimmed &&
      SECTION_ONLY_RE.test(trimmed) &&
      alreadyHeader &&
      op.attributes?.bold
    ) {
      out.push({
        attributes: { ...TITLE_ATTRS },
        insert: toSentenceCase(trimmed),
      });
      continue;
    }

    out.push(op);
  }
  return out;
}

function hasDescriptionTitle(ops) {
  return ops.some((op) => {
    const insert = typeof op.insert === "string" ? op.insert.trim() : "";
    return /^(DESCRIPCI[OÓ]N|DESCRIPTION|Descripci[oó]n|Description)$/i.test(
      insert
    );
  });
}

function ensureDescriptionTitle(ops) {
  if (hasDescriptionTitle(ops)) return ops;
  const isEnglish = ops.some((op) => {
    const insert = typeof op.insert === "string" ? op.insert : "";
    return /Characteristics and [Bb]enefits/i.test(insert);
  });
  return [
    ...titleOps(
      isEnglish ? SECTION_LABELS.descriptionEn : SECTION_LABELS.descriptionEs
    ),
    ...ops,
  ];
}

function cleanLeadingBulletNewlines(ops) {
  return ops.map((op) => {
    if (typeof op.insert !== "string") return op;
    if (op.attributes?.header || op.attributes?.list) return op;
    if (!op.insert.startsWith("\n")) return op;
    const trimmedStart = op.insert.replace(/^\n+/, "");
    if (!trimmedStart) return op;
    return { ...op, insert: trimmedStart };
  });
}

/**
 * Corrige deltas de Textos donde el título "Características y beneficios"
 * queda pegado al primer bullet, o el título solo viene en bold sin header.
 */
export function normalizeInternationalQuillContent(rawContent) {
  let delta;
  try {
    delta =
      typeof rawContent === "string" ? JSON.parse(rawContent) : rawContent;
  } catch {
    return rawContent;
  }
  if (!delta?.ops?.length) return rawContent;

  const fullText = delta.ops
    .map((op) => (typeof op.insert === "string" ? op.insert : ""))
    .join("");

  if (FEATURES_INLINE_RE.test(fullText)) {
    return JSON.stringify(rebuildFromFlatText(fullText));
  }

  const ops = cleanLeadingBulletNewlines(
    ensureDescriptionTitle(promoteSectionTitles(delta.ops))
  );
  return JSON.stringify({ ops });
}
